import { useState } from "react";

export const faqs = [
  {
    q: "How fast can I get a passport in Norman, OK?",
    a: "Through Fast Passport Center, expedited processing can be as fast as 24 hours depending on your eligibility and the processing option you select. Standard government processing through a Norman post office or acceptance clerk can take 2–6 months, especially during busy travel seasons. For OU students with semester abroad deadlines, OU Health physicians with conference schedules, and families with upcoming vacations, that timeline is simply not viable.",
  },
  {
    q: "Can I get an expedited passport in Norman for a study abroad program starting next month?",
    a: "Yes. For OU and UCN students with upcoming study abroad programs, we offer expedited passport processing in 5–14 days. For late applicants with programs starting in 2 weeks or less, our 24–72 hour emergency service is available. Call 877-253-0084 to confirm your timeline.",
  },
  {
    q: "Do OU students get any discount on expedited passport service?",
    a: "We offer group pricing for OU student organizations traveling together. Individual students receive the same competitive rates as any other customer. Our 5-day service starting at $249 is popular with students who need more speed than routine mail service.",
  },
  {
    q: "Can OU medical students and residents use your service for international rotations?",
    a: "Yes. OU Health medical students and residents frequently need passports for international clinical rotations and conferences. We work with medical programs that have strict departure dates and provide priority processing for healthcare professionals.",
  },
  {
    q: "Can I renew my passport for my OU study abroad trip without visiting a facility?",
    a: "Yes. If your most recent passport was issued when you were 16 or older, is undamaged, and was issued within the last 15 years, you can renew by mail — no facility visit needed. We handle the mailing directly to the State Department for faster processing.",
  },
  {
    q: "Do I need to drive to Oklahoma City for a passport agency appointment?",
    a: "Not with Fast Passport Center. The Oklahoma City Passport Agency at 301 NW 6th Street is about 20 miles from Norman, and appointments are often unavailable or weeks out. We provide a faster, simpler path through our reserved agency submission slots — you ship documents overnight from Norman and we handle the submission, no OKC drive required.",
  },
  {
    q: "How much does expedited passport processing cost for Norman residents?",
    a: "Our expedited service fees range from $149 for 2-week service to $499 for 24-hour emergency processing. State Department fees are paid separately. We are typically 30–100% lower than FedEx and Staples resellers.",
  },
  {
    q: "What if my Norman passport photos don't meet requirements?",
    a: "Many Walmart and CVS locations in Norman take passport photos that fail State Department specifications. We provide a photo compliance checklist before you submit and offer a remote photo review service to prevent rejection.",
  },
];

export default function NormanFAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-white py-20 md:py-28">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Questions?</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Frequently Asked <span className="text-[#F6C344]">Questions</span>
          </h2>
          <p className="text-gray-500 text-base">
            Everything Norman and Cleveland County travelers ask us most often about expedited passport services.
          </p>
        </div>

        <div className="space-y-2">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="bg-[#F7F8FA] rounded-lg border border-gray-200 overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between gap-4 p-5 text-left cursor-pointer"
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
              >
                <span className="font-semibold text-[#1A365D] text-sm leading-snug">{faq.q}</span>
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-[#1A365D] flex-shrink-0">
                  <i
                    className={`text-white text-sm transition-transform duration-200 ${
                      openIndex === i ? "ri-subtract-line" : "ri-add-line"
                    }`}
                  ></i>
                </div>
              </button>
              {openIndex === i && (
                <div className="px-5 pb-5">
                  <p className="text-gray-500 text-sm leading-relaxed border-t border-gray-200 pt-4">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <p className="text-gray-500 text-sm mb-4">Still have questions? Our team is here to help.</p>
          <a
            href="tel:8772530084"
            className="inline-flex items-center gap-2 bg-[#1A365D] hover:bg-[#0F2240] text-white font-semibold text-sm px-6 py-3 rounded-md transition-all whitespace-nowrap"
          >
            <i className="ri-phone-line"></i> Call 877-253-0084
          </a>
        </div>
      </div>
    </section>
  );
}